import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { SearchAssistantTriggerButton } from '@/components/SearchAssistant';

export const footerHeight = '2rem'; // 36px

const styles = {
  footer: {
    backgroundColor: theme => theme.palette.baseColors.deepSeaNavy.c100,
    color: theme => theme.palette.common.white,
    position: 'relative',
    left: 0,
    bottom: 0,
    zIndex: theme => theme.zIndex.footer,
    display: 'grid',
    placeItems: 'center',
    width: '100%',
    height: `${footerHeight}`,
    padding: '0 1rem',
    marginTop: 'auto',
  },
  searchAssistantContainer: theme => ({
    position: 'absolute',
    left: 0,
    bottom: '0.075rem',
    ...(theme.breakpoints.up('md')
      ? {
          translate: 'calc(calc(100vw - 100%) - 275px) 0 0',
        }
      : {}),
  }),
};

const Footer = () => {
  return (
    <Box as='footer' sx={styles.footer}>
      <Typography variant='overline'>
        COPYRIGHT © {new Date().getFullYear()} WELLIGENCE ENERGY ANALYTICS. ALL RIGHTS RESERVED.
      </Typography>
      <Box sx={styles.searchAssistantContainer}>
        <SearchAssistantTriggerButton />
      </Box>
    </Box>
  );
};

export default Footer;
